// import { Box, Typography } from '@mui/material';
import { Typography } from '@mui/material';
import { TrackedBox as Box } from '../components/tracked/TrackedBox2';
import React from 'react';
import { GroupsList } from '../components/custom/groups/GroupsList';
import { OriginsList } from '../components/custom/origins/OriginsListMobile';
import { PlatesList } from '../components/custom/plates/PlatesListMobile';
import { EntityList } from '../components/custom/entities/EntityListMobile';
import { EventList } from '../components/custom/events/EventListMobile';
import SetupComponent from '../components/custom/setup/Setup';
import ChooseCustomerForm from '../components/custom/admin/ChooseCustomerForm';
import { useTranslation } from 'react-i18next';
import HomeForm from '../components/custom/home/HomeFormMobile';
import { StatisticReport } from '../components/custom/home/StatisticReport2';
import { ReactionsList } from '../components/custom/reactions/ReactionsList';

// Component for the /points route
export const PointsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Points Management */}
        {/* Керування Локаціями */}
        {t('pages.Points_Management')}
      </Typography>
      
      <EntityList type={1}/>
      
    </Box>
  );
};

export const CheckPointsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Checkpoints Management */}
        {/* Керування Пунктами проїзду */}
        {t('pages.Checkpoints_Management')}
      </Typography>
      
      <EntityList type={2}/>
      
    </Box>
  );
};

// Component for the /origins route
export const OriginsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Origins Management */}
        {/* Керування Камерами */}
        {t('pages.Origins_Management')}
      </Typography>
      
      {/* <OriginTable /> */}
      <OriginsList/>
      
    </Box>
  );
};

export const ReactionsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('pages.Reactions_Management')}
      </Typography>
      
      <ReactionsList/>
      
    </Box>
  );
};

// Component for the /groups route
export const GroupsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Groups Management */}
        {/* Керування групами */}
        {t('pages.Groups_Management')}
      </Typography>
      <Typography variant="body1">
        {/* This is where you'll manage your groups. */}
        {/* Тут ви керуватимете своїми групами. */}
      </Typography>
      
      <GroupsList />
      
    </Box>
  );
};

// Component for the /plates route
export const PlatesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Plates Overview */}
        {/* Заведення номерних знаків */}
        {t('pages.Plates_Management')}
      </Typography>
      <Typography variant="body1">
        {/* This page shows the list of plates. */}
        {/* На цій сторінці показано список номерних знаків. */}
      </Typography>

      <PlatesList />
      
    </Box>
  );
};

// Component for the /setup route
export const SetupPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Application Setup */}
        {/* Налаштування програми */}
        {t('pages.Setup_Management')}
      </Typography>
      <SetupComponent />
    </Box>
  );
};
export const CustomersPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Customers Management */}
        {/* Керування клієнтами */}
        {t('pages.Customers_Management')}
      </Typography>
      
      <ChooseCustomerForm />
      
    </Box>
  );
};

// Optional: A component for the main/default route (like '/')
export const HomePage: React.FC = () => {
    // const { t } = useTranslation();
    return (
      <Box sx={{ p: 0 }}>
        <HomeForm/>
      </Box>
    );
  };

  // export const LoginPage: React.FC = () => {
  //   return (
  //     <Box sx={{ p: 3 }}>
  //       <LoginForm/>
  //     </Box>
  //     );
  // };

  // export const SignupPage: React.FC = () => {
  //   return (
  //     <Box sx={{ p: 3 }}>
  //       <SignupForm/>
  //     </Box>
  //     );
  // };


export const EventsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {/* Events */}
        {/* Перегляд подій */}
        {t('pages.Events_Management')}
      </Typography>
      
      <EventList/>
      
    </Box>
  );
};

export const StatisticReportPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('pages.StatisticReport')}
      </Typography>
      
      <StatisticReport/>
      
    </Box>
  );
};
